import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  CONSENT_LOG_GET_REQUEST,
  CONSENT_LOG_GET_SUCCESS,
  CONSENT_LOG_GET_FAILURE,
  CONSENT_LOG_GET_RESET,
  CONSENT_LOG_ACTIVATE_REQUEST,
  CONSENT_LOG_ACTIVATE_SUCCESS,
  CONSENT_LOG_ACTIVATE_FAILURE,
  CONSENT_LOG_CREATE_REQUEST,
  CONSENT_LOG_CREATE_SUCCESS,
  CONSENT_LOG_CREATE_FAILURE,
  COONSENT_LOG_DEACTIVATE_REQUEST,
  COONSENT_LOG_DEACTIVATE_SUCCESS,
  COONSENT_LOG_DEACTIVATE_FAILURE,
} from '../../constants'

export function getConsentLog(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent-log`,
      method: 'GET',
      types: [
        CONSENT_LOG_GET_REQUEST,
        CONSENT_LOG_GET_SUCCESS,
        CONSENT_LOG_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getConsentLogByEmpCode(empcode, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent-log/${empcode}`,
      method: 'GET',
      types: [
        CONSENT_LOG_GET_REQUEST,
        CONSENT_LOG_GET_SUCCESS,
        CONSENT_LOG_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getConsentLogByDocCode(doccode, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent-log/document/${doccode}`,
      method: 'GET',
      types: [
        CONSENT_LOG_GET_REQUEST,
        CONSENT_LOG_GET_SUCCESS,
        CONSENT_LOG_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function activateConsentLog(empcode, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent-log/${empcode}/activate`,
      method: 'PUT',
      types: [
        CONSENT_LOG_ACTIVATE_REQUEST,
        CONSENT_LOG_ACTIVATE_SUCCESS,
        CONSENT_LOG_ACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function createConsentLog(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent-log`,
      method: 'POST',
      types: [
        CONSENT_LOG_CREATE_REQUEST,
        CONSENT_LOG_CREATE_SUCCESS,
        CONSENT_LOG_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function deactivateConsentLog(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent-log/${id}/delete`,
      method: 'PUT',
      types: [
        COONSENT_LOG_DEACTIVATE_REQUEST,
        COONSENT_LOG_DEACTIVATE_SUCCESS,
        COONSENT_LOG_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function resetEditConsentLog() {
  return {
    type: CONSENT_LOG_GET_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/consent-logs/consent-log-action.js